import Typography from "../../Typography/Typography";
import styles from "./ButtonFotter.module.scss";

const ButtonFotter = ({ children, onClick, disabled = false }) => {
	return (
		<button
			className={styles.buttonFooter}
			onClick={onClick}
			disabled={disabled}
		>
			<Typography color="white" variant="h3">
				{children}
			</Typography>
		</button>
	);
};

export default ButtonFotter;
